import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";

// Elegant placeholder shown while products are not yet available.
export default function LaunchingSoonCard({ image, tone = "pharma", index = 0, label }) {
  const isSkin = tone === "skin";
  const accentBg = isSkin ? "bg-derma" : "bg-pharma";
  const accentText = isSkin ? "text-derma" : "text-pharma";

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: (index % 4) * 0.08 }}
      className="group relative aspect-[3/4] overflow-hidden rounded-[1.5rem] bg-surfalt"
      data-testid={`launching-soon-${tone}-${index}`}
    >
      {image && (
        <img
          src={image}
          alt=""
          className="absolute inset-0 w-full h-full object-cover grayscale opacity-40 transition-transform duration-[900ms] ease-out group-hover:scale-105"
        />
      )}
      <div className="absolute inset-0 bg-stone/40" />
      <div className="relative h-full flex flex-col justify-between p-6 md:p-8">
        <span className={`self-start rounded-full ${accentBg} text-stone px-3 py-1 text-[10px] uppercase tracking-[0.2em] font-sans flex items-center gap-1.5`}>
          <Sparkles size={11} /> {label || "New"}
        </span>
        <div>
          <p className="font-serif text-3xl md:text-4xl leading-[0.95] tracking-tight">
            Product<br />launching soon
          </p>
          <p className={`font-sans text-xs uppercase tracking-[0.2em] mt-3 ${accentText}`}>
            Stay tuned
          </p>
        </div>
      </div>
    </motion.div>
  );
}
